import { importClass } from "../../utilities/dynamicImportsUtility";

export default class InputButtonPriceElement extends HTMLElement {
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("Input Button Price Element registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private async initialize() {
    importClass(
      () =>
        import(
          /* webpackChunkName: "inputButtonPriceElementController" */ "./inputButtonPriceElementController"
        ),
      true,
      [this]
    );
  }
}

customElements.define("input-button-price-element", InputButtonPriceElement);
